import { formatDateForMcleod } from "../utils/dateHelpers";

export default class CallInStopsTimes {
  static stopsTimesSerializer(data) {
    const payload = {
      stopId: data.stopId,
      actualArrival: data.actualArrival !== null ? formatDateForMcleod(data.actualArrival) : null,
      actualDeparture: data.actualDeparture !== null ? formatDateForMcleod(data.actualDeparture) : null
    };
    return payload;
  }
}